import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalUtilityService {

  constructor() { }


  /**
   * Sort List of objects
   * 
   * @param list 
   * @param key 
   */
  sortArrayOfObjects(list:any, key:string){
    if(!list || list.length === 0) return [];

    return list.sort((a: object, b: object) => (a[key] > b[key]) ? 1 : -1)
  }

  /**
   * Sort List of deep objects
   * 
   * @param arr 
   * @param prop 
   */
  sortArrayOfDeepObjects( arr,prop) {
    prop = prop.split('.');
    var len = prop.length;

    arr.sort(function (a, b) {
        var i = 0;
        while( i < len ) { a = a[prop[i]]; b = b[prop[i]]; i++; }
        if (a < b) {
            return -1;
        } else if (a > b) {
            return 1;
        } else {
            return 0;
        }
    });
    return arr;
};

  /**
   * Combine multiple array of objects
   * @param parentObj 
   */
  combineMultipleArrayOfObjects(parentObj:object){
    let mergedArray = [];
    Object.keys(parentObj).forEach( key => {
        if(parentObj.hasOwnProperty(key) && typeof parentObj[key] === 'object' && parentObj[key].length > 0){
          mergedArray = mergedArray.concat(parentObj[key]);
        }
    });

    return mergedArray;
  }

  /**
   * Sort List of Object by multiple properties
   * @param fields 
   * @returns 
   */
   fieldSorter = (fields) => (a, b) => fields.map(o => {
    let dir = 1;
    if (o[0] === '-') { dir = -1; o=o.substring(1); }
    return a[o] > b[o] ? dir : a[o] < b[o] ? -(dir) : 0;
  }).reduce((p, n) => p ? p : n, 0);

  /**
   * Sort List of Object to single property
   * @param list
   * @param property 
   * @returns 
   */

  reduceObjectToProperty=(list:any,property:string)=>{
    return list.map(function(item) {
      return item[property];
    });
  }

  reduceObjectToTagListProperty=(list:any)=> {
    return list.map(function(item){
      return {tagId: item.tagId? item.tagId : "", sourceUnit: item.sourceUnit? item.sourceUnit : "", destinationUnit: item.destinationUnit? item.destinationUnit : ""};
    });
  }

  reduceObjectToTagId = (list:any) => {
    let temptagIds = [];
    list.forEach((item) => {
      temptagIds.push(item.tagId? item.tagId : "")
    });
    return temptagIds;
  }
  
}
